<template>
    <label>{{ label }}<slot></slot>
        <input type="checkbox" :checked="checked" :value="value" :id="'abi-'+name" :disabled="disabled" v-on="$listeners">
        <span class="checkmark"></span>
    </label>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: ""
        },
        checked: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: String,
            required: false,
            default: ""
        },
    }
}
</script>
<style scoped src="./Checkbox.css">
</style>